import { FolderTreeItem } from "../useQueryFolderTree";

// Sort folders alphabetically
export const alphabetizeFolders = (foldersArray: FolderTreeItem[] | []) => {
  return foldersArray.sort((a: FolderTreeItem, b: FolderTreeItem) =>
    new Intl.Collator("en").compare(a.name, b.name),
  );
};
